import {createContext} from 'react'

export const RuntimeContext = createContext({
  state: undefined,
  actions: undefined,
  host: {
    dimensions: {},
  },
} as any)
